"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLLECTION_API_URLS = void 0;
var COLLECTION_API_URLS;
(function (COLLECTION_API_URLS) {
    COLLECTION_API_URLS["CREATE"] = "/v2/collection/create";
    COLLECTION_API_URLS["UPDATE"] = "/v2/collection/update";
    COLLECTION_API_URLS["PUBLISH"] = "/v2/collection/set-is-published-state";
    COLLECTION_API_URLS["GET_INFO"] = "/v2/collection/get-info";
    COLLECTION_API_URLS["GET_INFO_BY_IDS"] = "/v2/collection/get-info-by-ids";
    COLLECTION_API_URLS["GET_ALL"] = "/v2/collection/get-all";
    COLLECTION_API_URLS["GET_MINE"] = "/v2/collection/get-mine";
    COLLECTION_API_URLS["GET_BY_USER"] = "/v2/collection/get-by-user";
    COLLECTION_API_URLS["GET_HOT"] = "/v2/collection/get-hot";
    COLLECTION_API_URLS["SEARCH"] = "/v2/collection/search";
    COLLECTION_API_URLS["HIGHLIGHTS"] = "/v2/collection/highlights";
    COLLECTION_API_URLS["GET_BY_FILTER"] = "/v2/collection/get-by-filter";
    COLLECTION_API_URLS["GET_STATISTICS"] = "/v2/collection/get-statistics";
})(COLLECTION_API_URLS = exports.COLLECTION_API_URLS || (exports.COLLECTION_API_URLS = {}));
